const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/admin/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { pickEnum, pickString } from "@/lib/search-params";
import { adminPageTitle } from "@/routes/_app/admin/admin-page-title";
import { ADMIN_ANALYTICS_TABS } from "./-admin-analytics-tabs";
import { ADMIN_ANALYTICS_RANGES } from "./-admin-delivery-analytics-query";
interface AdminHomeSearch {
  channel?: string;
  q?: string;
  range: AdminAnalyticsRange;
  /** Click stream store filter: a provider key. */
  store?: string;
  tab: AdminAnalyticsTab;
}
export const Route = createFileRoute("/_app/admin/")({
  head: () => ({
    meta: [{
      title: adminPageTitle("Analytics")
    }]
  }),
  validateSearch: (raw: Record<string, unknown>): AdminHomeSearch => ({
    channel: pickString(raw.channel),
    q: pickString(raw.q),
    range: pickEnum(raw.range, ADMIN_ANALYTICS_RANGES) ?? "24h",
    store: pickString(raw.store),
    tab: pickEnum(raw.tab, ADMIN_ANALYTICS_TABS) ?? "offer-clicks"
  }),
  // Private analytics render their loading states immediately and fetch in the browser.
  // Do not delay the page response with delivery-history aggregation.
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});